import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { withTranslation } from "react-i18next";
import "./errorBoundary.scss";

/**
 * Error Boundary global. Evita que un error de render desmonte toda la app
 * (pantalla en blanco). Muestra un fallback tokenizado con opción de recargar.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary capturó un error de render:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.assign("/");
  };

  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div className="error-boundary" role="alert">
          <div className="error-boundary__card">
            <span className="error-boundary__icon">
              <AlertTriangle size={28} strokeWidth={2} />
            </span>
            <h1 className="error-boundary__title">{t("Algo salió mal")}</h1>
            <p className="error-boundary__text">
              {t("Ocurrió un error inesperado en esta pantalla. Puedes recargar para volver a intentarlo; tu sesión no se pierde.")}
            </p>
            <div className="error-boundary__actions">
              <button
                type="button"
                className="error-boundary__btn error-boundary__btn--primary"
                onClick={this.handleReload}
              >
                <RefreshCw size={16} strokeWidth={2.2} />
                {t("Recargar la página")}
              </button>
              <button
                type="button"
                className="error-boundary__btn"
                onClick={this.handleHome}
              >
                {t("Ir al inicio")}
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
